/* eslint-disable no-restricted-imports */
import { AddLiquidity } from './actions/addLiquidity';
import { AddLiquidityETH } from './actions/ETH/addLiquidityETH';
import { RemoveLiquidityETH } from './actions/ETH/removeLiquidityETH';
import { SwapExactETHForTokens } from './actions/ETH/SwapExactETHForTokens';
import { SwapExactTokensForETH } from './actions/ETH/SwapExactTokensForETH';
import { RemoveLiquidity } from './actions/removeLiquidity';
import { SimpleSwap } from './actions/SimpleSwap';
import { SwapExactTokensForTokens } from './actions/SwapExactTokensForTokens';
import { GetAmountsIn } from './getters/GetAmountsIn';
import { GetAmountsOut } from './getters/GetAmountsOut';
var actions = {
    SwapExactTokensForTokens: SwapExactTokensForTokens,
    SwapExactETHForTokens: SwapExactETHForTokens,
    SwapExactTokensForETH: SwapExactTokensForETH,
    SimpleSwap: SimpleSwap,
    AddLiquidity: AddLiquidity,
    RemoveLiquidity: RemoveLiquidity,
    AddLiquidityETH: AddLiquidityETH,
    RemoveLiquidityETH: RemoveLiquidityETH,
};
var getters = {
    GetAmountsOut: GetAmountsOut,
    GetAmountsIn: GetAmountsIn,
};
var Sushiswap = {
    actions: actions,
    getters: getters,
};
export { Sushiswap };
